import AOS from 'aos';

export default {
  init() {

    if (window.innerWidth >= 1200) {
      var g = $('.wrap-accueil .lettre.g').offset();
      var u = $('.wrap-accueil .lettre.u').offset();
      var i = $('.wrap-accueil .lettre.i').offset();
      var d = $('.wrap-accueil .lettre.d').offset();
      var i2 = $('.wrap-accueil .lettre.i2').offset();

      $('.wrap-accueil').on('mousemove', function (e) {
        $('.wrap-accueil .lettre.g').each(function () {
          var x;
          if (e.pageX > (window.innerWidth / 2)) {
            x = -((e.pageX - g.left) / 10);
          } else {
            x = ((g.left - e.pageX) / 10);
          }
          var y;
          if (e.pageY > (window.innerHeight / 2)) {
            y = -((e.pageY - (window.innerHeight / 2)) / 10);
          } else {
            y = (((window.innerHeight / 2) - e.pageY) / 10);
          }
          $(this).css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        });

        $('.wrap-accueil .lettre.u').each(function () {
          var x;
          if (e.pageX > (window.innerWidth / 2)) {
            x = -((e.pageX - u.left) / 20);
          } else {
            x = ((u.left - e.pageX) / 20);
          }
          var y;
          if (e.pageY > (window.innerHeight / 2)) {
            y = -((e.pageY - (window.innerHeight / 2)) / 20);
          } else {
            y = (((window.innerHeight / 2) - e.pageY) / 20);
          }
          $(this).css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        });

        $('.wrap-accueil .lettre.i').each(function () {
          var x;
          if (e.pageX > i.left) {
            x = -((e.pageX - i.left) / 10);
          } else {
            x = ((i.left - e.pageX) / 10);
          }
          var y;
          if (e.pageY > i.top) {
            y = -((e.pageY - i.top) / 10);
          } else {
            y = ((i.top - e.pageY) / 10);
          }
          $(this).css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        });

        $('.wrap-accueil .lettre.d').each(function () {
          var x;
          if (e.pageX > d.left) {
            x = -((e.pageX - d.left) / 20);
          } else {
            x = ((d.left - e.pageX) / 20);
          }
          var y;
          if (e.pageY > d.top) {
            y = ((e.pageY - d.top) / 20);
          } else {
            y = -((d.top - e.pageY) / 20);
          }
          $(this).css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        });

        $('.wrap-accueil .lettre.i2').each(function () {
          var x;
          if (e.pageX > i2.left) {
            x = -((e.pageX - i2.left) / 10);
          } else {
            x = ((i2.left - e.pageX) / 10);
          }
          var y;
          if (e.pageY > i2.top) {
            y = ((e.pageY - i2.top) / 10);
          } else {
            y = -((i2.top - e.pageY) / 10);
          }
          $(this).css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        });
      });

      // JavaScript to be fired on the home page
      $('#sections').pagepiling({
        scrollingSpeed: 280,
        anchors: ['accueil', 'a-propos', 'services', 'une', 'sur-mesure', 'dezweb', 'equipe', 'blogue', 'contact'],
        onLeave: function (index, nextIndex) {
          $('#pp-nav ul .dot').css('top', ((nextIndex - 1) * 28) + 'px');

          setTimeout(function () {
            $('.section .aos-init').attr('data-aos-duration', '0').removeClass('aos-animate').removeClass('aos-init').addClass('invisible').addClass('aos-toggle');
            $('.section .aos-toggle').attr('data-aos-duration', '0').removeClass('aos-animate').removeClass('aos-init').addClass('invisible').addClass('aos-toggle');
          }, 400)

        },
        afterLoad: function () {

          setTimeout(function () {
            //$('.section:not(.active) .aos-init').attr('data-aos-duration', '0').removeClass('aos-animate');
            $('.section.active .aos-toggle').removeClass('invisible').addClass('aos-init').attr('data-aos-duration', '700');
            AOS.refresh();
          }, 500)

        },
        afterRender: function () {
          $('#pp-nav ul').append('<li data-tooltip="" class="dot"></li>');
        },
      });
    } else {
      $('html').addClass('no-pagepiling');

      $('.close-contact').on('click', function () {
        $('html, body').animate({
          scrollTop: $('.wrap-contact').offset().top,
        }, 700);
      });

      if (location.hash) {
        if ($('.section[data-anchor='+location.hash.slice(1)+']').length > 0) {
          $('html, body').animate({
            scrollTop: $('.section[data-anchor='+location.hash.slice(1)+']').offset().top,
          }, 700);
        }
      }
    }

    $('.close-contact').on('click', function () {
      $('body').removeClass('menu-open');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/home.js